export const POLECAJ_ICONS = {
  browser: 'https://cdn.naviparking.com/digital_parking/assets/browser.svg',
  parking: 'https://cdn.naviparking.com/digital_parking/assets/parking-2.svg',
  lightbulb: 'https://cdn.naviparking.com/digital_parking/assets/lightbulb.svg'
} as const

export type PolecajIconKey = keyof typeof POLECAJ_ICONS

export const getPolecajIcon = (iconKey: PolecajIconKey): string => {
  return POLECAJ_ICONS[iconKey]
}
